export const entry = (contractor: any, effectiveDate: string) => {
  const officeAddresses = contractor.offices.map((office: any) => office.address).join(', ');

  return [
    { text: '     Transportation Independent Contractor Agreement', style: 'h1' },

    {
      text: [
        { text: '     This Transportation Contractor Agreement (“TICA” or “Agreement”) dated ' },
        { text: `${effectiveDate} (“Effective Date”) `, bold: true },
        { text: 'is made and entered into by and between ' },
        { text: 'Sierra Expediting Inc.,', bold: true },
        { text: ` a Missouri-registered motor carrier, hereinafter referred to as "Company", and` },
        { text: ` ${contractor.name}`, bold: true },
        { text: ', a ' },
        { text: `${contractor.type}`, bold: true },
        { text: `with offices located at ` },
        { text: `${officeAddresses}`, bold: true },
        { text: `, hereinafter referred to as` },
        { text: ` “Independent Contractor”`, bold: true },
        { text: `,` },
        { text: ` (collectively, the “Parties”)`, bold: true },
        { text: ` as follows:` },
      ],
      style: 'p',
    },
  ];
};
